/**
 * @copyright Copyright (c) 2015, Pacific Biosciences of California, Inc.
 * @author <a href="mailto:bskinner@pacificbiosciences.com">Brian Skinner</a>
 */

import {Facet} from "../facets/facet"
import {BED_FRAME} from "../frames/bedfile"
import { multisort, desc, valueToDate } from "../../core/utils/property-sort"

export const BED_FACET = new Facet({
    frame: BED_FRAME,
    defaultColumns:
        ["id", "name", "numRecords", "totalLength", "updatedAt", "createdAt"],
    initialSort: multisort(desc(valueToDate("updatedAt")), desc(valueToDate("createdAt"))),
    additionalColumns: [
        "uuid", "path",
        "tags", "projectId", "version", "md5", "createdBy", "comments"],
    displayProperties: [
        "name", "updatedAt", "numRecords", "totalLength", "createdAt",
        "id", "uuid", "path",
        "tags", "projectId", "version", "md5", "createdBy", "comments"]
})
